'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        usePreset: {
            type: Boolean,
            default: true
        },
        networkList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        network: {
            type: Object,
            default: null
        }
    },
    data: function data() {
        return {
            name: '',
            server: '',
            port: 6667,
            tls: false,
            presetNetworks: [],
            showCustom: true,
            willEmit: false
        };
    },
    computed: {
        presetServer: {
            set: function set(newVal) {
                if (newVal === 'custom') {
                    this.name = '';
                    this.server = '';
                    this.port = 6667;
                    this.tls = false;

                    this.showCustom = true;
                } else {
                    var addr = this.parseFormatted(newVal);
                    this.name = addr.name;
                    this.server = addr.server;
                    this.port = addr.port;
                    this.tls = addr.tls;

                    this.showCustom = false;
                }
            },
            get: function get() {
                return this.showCustom ? 'custom' : this.toUri(this);
            }
        }
    },
    watch: {
        server: function server() {
            this.emitValue();
        },
        port: function port() {
            this.emitValue();
        },
        tls: function tls() {
            this.emitValue();
        }
    },
    created: function created() {
        var _this = this;

        if (this.networkList) {
            this.importUris(this.networkList);
        }
        if (this.network) {
            this.server = this.network.connection.server;
            this.port = parseInt(this.network.connection.port, 10);
            this.tls = this.network.connection.tls;

            if (_lodash2.default.find(this.presetNetworks, function (s) {
                var match = s.server === _this.server && s.port === _this.port && s.tls === _this.tls;
                return match;
            })) {
                this.showCustom = false;
            }
        }
    },

    methods: {
        toUri: function toUri(s) {
            return s.server + ':' + (s.tls ? '+' : '') + s.port;
        },
        emitValue: function emitValue() {
            var _this2 = this;

            if (this.willEmit) {
                return;
            }

            this.willEmit = true;

            this.$nextTick(function () {
                _this2.willEmit = false;

                _this2.$emit('input', {
                    server: _this2.server,
                    port: _this2.port,
                    tls: _this2.tls
                });

                if (_this2.network) {
                    _this2.network.connection.server = _this2.server;
                    _this2.network.connection.port = _this2.port;
                    _this2.network.connection.tls = _this2.tls;
                }
            });
        },

        toggleTls: function toggleTls() {
            this.tls = !this.tls;

            if (this.tls && this.port === 6667) {
                this.port = 6697;
            } else if (!this.tls && this.port === 6697) {
                this.port = 6667;
            }
        },
        parseFormatted: function parseFormatted(input) {
            var ret = {
                name: '',
                server: '',
                port: 6667,
                tls: false
            };

            var val = input;

            var pipePos = val.indexOf('|');
            if (pipePos > -1) {
                ret.name = val.substr(0, pipePos);
                val = val.substr(pipePos + 1);
            }

            var colonPos = val.indexOf(':');
            if (colonPos === -1) {
                ret.server = val;
                val = '';
            } else {
                ret.server = val.substr(0, colonPos);
                val = val.substr(colonPos + 1);
            }

            if (val[0] === '+') {
                ret.tls = true;
                val = val.substr(1);
            }

            if (val.length > 0) {
                ret.port = parseInt(val, 10);
                val = '';
            }

            if (!ret.name) {
                ret.name = ret.server;
            }

            return ret;
        },
        importUris: function importUris(serverList) {
            var _this3 = this;

            var servers = serverList.map(function (s) {
                return _this3.parseFormatted(s);
            });
            this.$set(this, 'presetNetworks', servers);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ServerSelector"]
window._kiwi_exports.components.ServerSelector = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ServerSelector.vue
// module id = kZ1f
// module chunks = 1